<template>
  <div>
    <SectionTitle>Atividades recentes</SectionTitle>

    <div class="box">
      <div class="box__inner">
        <div class="box__inner__deep">
          <TimelineActivities :user-id="user.id"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TimelineActivities from '@/components/timeline/TimelineActivities.vue'
import SectionTitle from '@/components/text/titles/SectionTitle'

export default {
  components: {
    SectionTitle,
    TimelineActivities
  },

  props: {
    user: { type: Object, required: true }
  }
}
</script>

<style scoped lang="scss">
  .box {
    border: 1px solid rgba(#000, .1);
    padding: 10px;
    border-radius: 10px;

    &__inner {
      // @media (min-width: 768px) {
      //   max-height: 37.5rem;
      // }

      overflow: auto;
  
      &::-webkit-scrollbar {
        width: 3px;
      }

      

      &__deep {
        padding-right: 10px;
      }
    }
  }
</style>